module.exports = __webpack_public_path__ + "static/media/SLIDERS-EXP-600.3ad112d2.png";